import {Component, Input, OnInit} from '@angular/core';

import * as $ from 'jquery';
import {DocumentFile} from "../../model/document-file";
import {DocumentFolder} from "../../model/documentFolder";
import {DownloadService} from "../../service/download.service";

@Component({
  selector: 'app-file-explorer-position',
  templateUrl: './file-explorer-position.component.html',
  styleUrls: ['./file-explorer-position.component.css']
})
export class FileExplorerPositionComponent implements OnInit {

  @Input() folder: DocumentFolder;
  @Input() files: Array<DocumentFile>;

  constructor(private downloadService: DownloadService) {
  }

  ngOnInit(): void {
  }

  toggleFolder(id) {
    $(".folder[folder-id='"+ id + "']").toggle();
    $(".folder-opened[folder-id='"+ id + "']").toggle();
    $(".folder-closed[folder-id='"+ id + "']").toggle();
  }
  downloadDocumentFile(id) {
    this.downloadService.downloadDocumentFileById(id);
  }
}
